/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Snackbar,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import CustomFieldForm from "../../components/CustomFieldForm";
import { PaperComponent } from "../../utils/constants";

const defaultValue = {
  ma: "",
  ten: "",
  ghichu: "",
  sothutu: 1,
};

const FormDonViHoiDong = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
}) => {
  // state lỗi giá trị từ form
  const formRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Mã đơn vị",
        key: "ma",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Tên đơn vị",
        key: "ten",
        type: "text",
        required: true,
        maxLength: 255,
        xs: 8,
        md: 6,
        lg: 6,
      },
      {
        name: "Số thứ tự",
        key: "sothutu",
        type: "number",
        xs: 4,
        md: 2,
        lg: 2,
      },
      {
        name: "Ghi chú",
        key: "ghichu",
        type: "textArea",
        maxLength: 255,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
    } else {
      setDataState(defaultValue);
    }
  }, [data]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    if (action == "Edit") {
      _data["id"] = data?.id;
      _data["rowIndex"] = data?.rowIndex;
    }
    const newValidationErrors = validateOBJ(_data);
    let _tempValid = newValidationErrors;
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };
  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
    }
  }, [open]);

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <>
      {alert.alert && (
        <Snackbar
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={alert.alert}
          onClose={handleCloseAlert}
        >
          <Alert onClose={handleCloseAlert} severity={alert.type}>
            {alert.message}
          </Alert>
        </Snackbar>
      )}
      <Dialog
        open={open}
        PaperComponent={PaperComponent}
        onClose={handelClear}
        scroll="paper"
      >
        {/* Form*/}
        <form
          ref={formRef}
          method="post"
          encType="multipart/form-data"
          style={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            height: "100%",
          }}
        >
          {/* Tiêu đề modal - tham số title */}
          <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
            {title ? title : "Chỉnh sửa Đơn vị"}
            <IconButton
              aria-label="close"
              onClick={handelClear}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
            <Box>
              {/* show lỗi từ khi không xác định được từ các field ở form */}
              {errors && errors.error ? (
                <Grid container sx={{ textAlign: "center", mb: 0 }}>
                  <Grid item xs={12}>
                    <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                      {errors.error}
                    </Alert>
                  </Grid>
                </Grid>
              ) : (
                ""
              )}

              {fieldInfor?.length > 0 && (
                <CustomFieldForm
                  key={"fieldInfor"}
                  listField={fieldInfor}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                  listOptionDic={{}}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handelClear}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Lưu
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

function validateOBJ(dv) {
  let result = {
    ma: !validateRequired(dv.ma) ? "Mã đơn vị không được trống" : "",
    ten: !validateRequired(dv.ten) ? "Tên đơn vị không được trống" : "",
  };
  return result;
}
export default FormDonViHoiDong;
